import { IApiResponse } from "common//models";
import { API_CONFIG, LOCAL_URL, PRODUCTION, UAT } from "common/config";
import { COMMON_JS } from "common/scripts";

interface IApiMasters {
  manageVehicleType: (args: any) => Promise<IApiResponse>;
  getVehicleTypes: (args: any) => Promise<IApiResponse>;
  getAxles: (args: any) => Promise<IApiResponse>;
  getBodyTypes: (args: any) => Promise<IApiResponse>;
  getPassingtons: (args: any) => Promise<IApiResponse>;
  manageCharge: (args: any) => Promise<IApiResponse>;
  getCharges: (args: any) => Promise<IApiResponse>;
  manageAsset: (args: any) => Promise<IApiResponse>;
  getAssets: (args: any) => Promise<IApiResponse>;
  manageTempRange: (args: any) => Promise<IApiResponse>;
  getTempRanges: (args: any) => Promise<IApiResponse>;
  manageVehicleAddon: (args: any) => Promise<IApiResponse>;
  manageUserType: (args: any) => Promise<IApiResponse>;
  getUserType: (args: any) => Promise<IApiResponse>;
  manageVehicle: (args: any) => Promise<IApiResponse>;
  getVehicles: (args: any) => Promise<IApiResponse>;
  manageDriver: (args: any) => Promise<IApiResponse>;
  getDrivers: (args: any) => Promise<IApiResponse>;
  manageTransporter: (args: any) => Promise<IApiResponse>;
  getTransporters: (args: any) => Promise<IApiResponse>;
  manageVehicleMaintenance: (args: any) => Promise<IApiResponse>;
  getVehicleMaintenances: (args: any) => Promise<IApiResponse>;
  manageRouteExpense: (args: any) => Promise<IApiResponse>;
  getRouteExpenses: (args: any) => Promise<IApiResponse>;
  manageContract: (args: any) => Promise<IApiResponse>;
  getContracts: (args: any) => Promise<IApiResponse>;
}

const local = PRODUCTION === "false" && UAT === "false";

export class ApiMasters implements IApiMasters {
  getVehiclesOnMap = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/3RFIHMTXP9K25ZG1";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageCustomer = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/ma/v1/PW57IAM3H2Y8XOZQ",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getCustomers = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/L821RVGBJ4I9SZNT";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageContract = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/ZWED9YTIG52OVRPJ";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };
  getContracts = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/2ZTDQHJY4PR1OX5A";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageRouteExpense = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/ma/v1/K4W8EX31URBY5MVZ",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };
  getRouteExpenses = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/ma/v1/GUZ8R7C0B51W3O6E",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageVehicleMaintenance = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/UA2G5LO9QRPYWDV4";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };
  getVehicleMaintenances = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/3O6CV7Z1N9G5UFWS";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageVehicleType = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/ma/v1/SEBD3YTXQG820L4O",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };
  getVehicleTypes = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/9ZG4UFEHR801V53L";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getAxles = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/JN2O1QWM9DV3YFRI";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getBodyTypes = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/CFOWLPIMUZ6J8GK3";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getPassingtons = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/KHV51RPNWBF4JU2S";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageCharge = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/ma/v1/UMX7LW1PG654BDNV",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };
  getCharges = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/A7ERZ3XM109PSLC4";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageAsset = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/7H8FQNAXGVLJPYSW";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };
  getAssets = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/NGP7SBQK9D1O8XMY";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageTempRange = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/ma/v1/N7QV9BWJZ4EY2G58",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };
  getTempRanges = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/KMQRO25J1FT8IP43";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageVehicleAddon = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/ma/v1/EY3FON8U1KH4IXG9",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getVehicleAddons = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/ma/v1/PYKRLJ7MUQA6NCFZ",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageUserType = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/ma/v1/YP5GC46T9HFB30NM",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getUserType = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/KZPSR73Y8EI1BMA6";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageVehicle = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/T251H3XGPCFKB6ML";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getVehicles = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/ERITOHFB537JP1UW";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageDriver = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/S45E12R3J8B6LVUQ";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageDrivers = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/NSWJ8Q0R5ZT0VF60";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getDrivers = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/5CMFQVISDB27O1P9";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageTransporter = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/ma/v1/PW57IAM3H2Y8XOZQ",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getTransporters = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/L821RVGBJ4I9SZNT";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageVehicleFiles = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/S1G5HIXRBJMEQLT2";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getVehicleFileInfo = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/T8F3CSZWK0YMVN4A";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageMaintenanceFiles = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/1PZMA5YWDCEHVUTG";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getMaintenanceFileInfo = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/NPFX7UY0WGRJD9K3";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageDriverFiles = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/IRSO8FXWLE67Z9DK";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getDriverFileInfo = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ma/v1/M1KQ6B304RDZSN2G";
      if (local) {
        apiUrl = LOCAL_URL + ":8003" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };
}
